<template>
    <v-content>
        <v-layout align-center justify-center fill-height>
                <div v-if="info_invitation[0].canceled === true" id="overlayersss">
                  <div id="textoss">
                    <h2>{{$t('canceled_invitation')}}</h2><br>
                    <h3>{{$t('msg_canceled_invitation_offline')}}</h3><br>
                  </div>
                </div>
                <v-flex xs12 sm7 md6 lg5 xl3>
                    <h2 style="text-align: center;">
                        <strong>
                            <span style=" text-align: center;">{{$t('msg_invitation_company_01')}}</span>
                        </strong>
                    </h2>
                    <p style="text-align: center;">
                        <span style="background-color: #2b2301; color: #fff; display: inline-block; padding: 3px 10px; font-weight: bold; border-radius: 5px;">{{ info_invitation[0].company }}</span>
                        <br>
                        <img
                            :src="info_invitation[0].logo"
                            width="150px"
                        >
                    </p>
                    <p style="text-align: center;"><strong>{{$t('Anfitrion')}}: {{ info_invitation[0].host }}</strong></p>
                    <p style="text-align: center;"><strong>{{$t('Area')}}: {{ info_invitation[0].area }}</strong></p>
                    <p style="text-align: center;">{{$t('msg_invitation_02')}}</p>
                    <p style="text-align: center;"><strong>{{$t('fecha_hora')}}: {{ info_invitation[0].date }}  {{info_invitation[0].time}}</strong></p>
                    <p v-if="info_invitation[0].typeInv === 2 && info_invitation[0].diary !== ''" style="text-align: center;"><strong>{{$t('fecha_expiracion')}}: {{ info_invitation[0].expiration }}</strong></p>
                    <p v-if="info_invitation[0].typeInv === 2 && info_invitation[0].diary !== ''"  style="text-align: center;"><strong>{{$t('dias_validos')}}</strong></p>
                    <ul v-if="info_invitation[0].typeInv === 2 && info_invitation[0].diary !== ''" style="list-style: none; text-align: center;">
                        <li v-if="info_invitation[0].diary.includes('0') === true">
                            {{ $t('Lunes') }}
                        </li>
                        <li v-if="info_invitation[0].diary.includes('1') === true">
                            {{ $t('Martes') }}
                        </li>
                        <li v-if="info_invitation[0].diary.includes('2') === true">
                            {{ $t('Miercoles') }}
                        </li>
                        <li v-if="info_invitation[0].diary.includes('3') === true">
                            {{ $t('Jueves') }}
                        </li>
                        <li v-if="info_invitation[0].diary.includes('4') === true">
                            {{ $t('Viernes') }}
                        </li>
                        <li v-if="info_invitation[0].diary.includes('5') === true">
                            {{ $t('Sabado') }}
                        </li>
                        <li v-if="info_invitation[0].diary.includes('6') === true">
                            {{ $t('Domingo') }}
                        </li>
                    </ul>
                    <v-card>
                        <v-toolbar class="mb-auto" dark color="primary">
                            <v-toolbar-title style="text-align: center;">
                                {{$t('qr_code')}}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text class="mt-2">
                                <p style="text-align: center;" v-show="info_invitation[0].multiple_accesses">{{$t('msg_multiple_accesses')}}</p>
                                <v-flex xs12>
                                    <v-img
                                            class="centrado"
                                            :src="url"
                                            width="200"
                                            height="200"
                                    >
                                    </v-img>
                                    <!--<p style="text-align: center;">-->
                                        <!--<strong><span style="color: #000000;">Código: {{ codigo_qr }}</span></strong>-->
                                    <!--</p>-->
                                    <div v-if="info_invitation[0].secEqu.length > 0">
                                        <h4 style="text-align: center;">{{$t('mensaje_equipo')}}</h4>
                                        <ul style="text-align: center;" v-for="item in info_invitation[0].secEqu">
                                            <li style="list-style:none;"><strong>{{item.nameEquipment}}</strong></li>
                                        </ul>
                                    </div>
                                    <p style="text-align: center;" v-if="info_invitation[0].filesInvitation !== null">
                                        <strong><span style="color: #000000;">{{$t('msg_files_necessary_attend_invitation')}}</span></strong>
                                        <div v-if="info_invitation[0].filesInvitation !== null">
                                            <ul style="text-align: center;" v-for="item in info_invitation[0].filesInvitation">
                                                <li style="list-style:none;"><strong><a :href=item[0]>{{item[1]}}</a></strong></li>
                                            </ul>
                                        </div>
                                    </p>
                                    <p style="text-align: center;">
                                        <strong><span style="color: #000000;">{{$t('msg_confirm_assistance')}}</span></strong>
                                    </p>
                                    <div v-if="info_invitation[0].confirmed === false" style="text-align: center;">
                                        <v-btn
                                                class="white--text"
                                                :href="url_confirmar"
                                                color="primary"
                                        >
                                            <v-icon left dark>check</v-icon>{{$t('confirmar_asistencia')}}
                                        </v-btn>
                                    </div>
                                    <div v-else style="text-align: center;"><p>
                                        <strong><span style="color: #000000;">{{$t('confirmed_assistance')}}</span></strong></p>
                                    </div>
                                    <div style="text-align: center;">
                                        <a :href="urlWallet">
                                            <v-img
                                                    class="centrado"
                                                    border="0"
                                                    :src="require('../assets/wallet.png')"
                                                    width="150"
                                                    contain>
                                            </v-img>
                                        </a>
                                    </div>
                                    <br>
                                    <div style="text-align: center;">
                                        <v-icon>place</v-icon>
                                        <a :href="info_invitation[0].urlmap">Ubicación en Google Maps</a>
                                    </div>
                                </v-flex>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
    </v-content>
</template>

<script>
    export default {
        name: "qr_code",
        data(){
            return{
                url: "https://api.qrserver.com/v1/create-qr-code/?data=" + this.$route.params['qrcode'] + "&ecc=M&margin=20&size=400x400",
                codigo_qr: this.$route.params['qrcode'],
                url_confirmar: "https://empresa-service.intrare.app/setConfirmed_AppointmentFromMail/" + this.$route.params['qrcode'] + "/True",
                urlWallet: "https://empresa-service.intrare.app/wallet/create/" + this.$route.params['qrcode'],
                info_invitation: [],
            }
        },
        created: async function (){
            await this.get_info_invitation()
        },
        methods:{
            get_info_invitation(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/get_inv/qr/' + this.$route.params['qrcode'] + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language,
                    },
                };
                axios(config)
                    .then(result => {
                        this.info_invitation = result.data
                        console.log(this.info_invitation)
                    })
                    .catch(error => {
                        console.log(error)
                    })
            }
        }
    }
</script>

<style scoped>
    .centrado{
        display:block;
        margin-left: auto;
        margin-right: auto;
    }

    #overlayersss {
      position: fixed;
      display: block;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0,0,0,0.5);
      z-index: 2;
      cursor: pointer;
    }

    #textoss{
      position: absolute;
      top: 50%;
      left: 50%;
      font-size: 30px;
      color: white;
      text-align: center;
      transform: translate(-50%,-50%);
      -ms-transform: translate(-50%,-50%);
    }
</style>
